export default __webpack_public_path__ + "static/media/ls1_g04.eb1871bd.png";